import React, { useEffect, useState, useCallback } from 'react';
import ApiResponseModal from '@/views/app/ui/components/api-response-modal';
import { API_RESPONSE_MODAL_EVENT } from '@/config/helper/notification';
import { NOTIFY_DEFAULTS } from '@/config/notification-config';

const ApiResponseModalProvider = () => {
  const [state, setState] = useState({
    isOpen: false,
    type: NOTIFY_DEFAULTS.type,
    title: NOTIFY_DEFAULTS.title,
    message: NOTIFY_DEFAULTS.message,
    buttonText: NOTIFY_DEFAULTS.buttonText,
  });

  const handleEvent = useCallback((e) => {
    const { type, title, message, buttonText } = e.detail || {};
    setState({
      isOpen: true,
      type,
      title,
      message,
      buttonText: buttonText ?? NOTIFY_DEFAULTS.buttonText,
    });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, isOpen: false }));
  }, []);

  useEffect(() => {
    window.addEventListener(API_RESPONSE_MODAL_EVENT, handleEvent);
    return () => window.removeEventListener(API_RESPONSE_MODAL_EVENT, handleEvent);
  }, [handleEvent]);

  return (
    <ApiResponseModal
      isOpen={state.isOpen}
      type={state.type}
      title={state.title}
      message={state.message}
      buttonText={state.buttonText}
      onClose={close}
    />
  );
};

export default ApiResponseModalProvider;